import { render, staticRenderFns } from "./SafetyScreeningReportView.vue?vue&type=template&id=06350598&scoped=true"
import script from "./SafetyScreeningReportView.vue?vue&type=script&lang=ts"
export * from "./SafetyScreeningReportView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06350598",
  null
  
)

export default component.exports